import {Component} from 'react';
import { Card, Modal, Button } from 'react-bootstrap'

import { expandIcon } from '../../img/font_awesome/font_awesome';
import configData from "../../config/config.json";

class LoginPageSlides extends Component {

    state = {
        showLoginSlideModals: [false, false, false, false, false, false],
        altText: []
    }

    handleClick = (event) => {
        event.preventDefault();
        const clickedId = event.target.parentElement.parentElement.id; // find the closest parent
        let show = [false, false, false, false, false, false];
        show[clickedId] = true;

        this.setState({
            showLoginSlideModals: show
        })
     }

     handleCloseClick = (event) => {
        event.preventDefault();
        this.setState({
             showLoginSlideModals: [false, false, false, false, false, false]
        })
    }

    handleKeyDown = (event) => {
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
            const clickedId = event.target.parentElement.id; 
            let show = [false, false, false, false, false, false];
            show[clickedId] = true;
            this.setState({
                showLoginSlideModals: show
            })
        }
    }

    fetchAltText = () => {
		fetch(configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/slideAltText.json")
			.then((res) => res.text())
			.then((text) => {
				const altTextObject = JSON.parse(text);
                const altText = Object.values(altTextObject);
				this.setState({
					altText
				});
			})
			.catch((e) => console.error(e));

	}

    componentDidMount() {
        this.fetchAltText();
    }

    render() {
        const slide1 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/one.jpg";
		const slide2 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/two.jpg";
		const slide3 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/three.jpg";
		const slide4 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/four.jpg";
		const slide5 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/five.jpg";
		const slide6 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/six.jpg";

        let slideArray = [slide1, slide2, slide3, slide4, slide5, slide6];
        let loginPageSlides = [];
        let loginPageSlideModals = [];

        for (var i = 0; i < this.props.numberOfSlides; i++) {
            loginPageSlides.push(
                <Card key={i} style={{ cursor: "pointer"}} >
                    <div id={i} style={{ position: 'relative', top: 0, left: 0 }} onClick={this.handleClick} >
                        <div style={{ position: 'relative', top: 0, left: 0 }}> <Card.Img variant="top" alt={this.state.altText[i]} src={slideArray[i]} /></div>
                        <div style={{ position: 'absolute', bottom: 5, right: 15, width: 'inherit', background: 'white', color: '#3675A5', paddingLeft: 2, paddingRight: 2 }} onKeyDown={this.handleKeyDown} tabIndex={0}>  {expandIcon}  <span className="sr-only">Enlarge</span> </div>
                    </div>
                </Card>);
            loginPageSlideModals.push(
                <Modal key={i} show={this.state.showLoginSlideModals[i]} onHide={this.handleCloseClick} size="xl" centered>
                    <Modal.Body style={{ borderTop: '2px solid black', borderBottom: '2px solid black', background: '#145A7B' }}>
                        <img border="0" src={slideArray[i]} alt={this.state.altText[i]} class="img-fluid" />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseClick}>Close</Button>
                    </Modal.Footer>
                </Modal>
            );
        }

        if (loginPageSlides.length === 0) {
            loginPageSlides.push(<Card><Card.Img variant="top" src={slide1} /></Card>);
        }

        return (
            <>
                { loginPageSlides }
                { loginPageSlideModals }
            </>
        )
    }
}

export default LoginPageSlides;
